import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Prospect } from '../../models/prospect.model';
import { environment } from '../../../environments/environment';
import { QuotationInputs, QuotationPaymentsInputs, KidPricingData } from '../../models/quoting';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private REQUESTS_URI: string = `${environment.URL_API}/mail/contact-mail`
  private EMPLOYMENT_URI: string = `${environment.URL_API}/mail/employment-mail`
  private quoteRouter: string = `${environment.URL_API}/quotes`

  private headers = { Authorization: `${environment.JWT_TOKEN}` };

  constructor(
    private http: HttpClient,
  ) { }

  async sendFormContact(contact: any) {
    try {
      return this.http.post<any>(this.REQUESTS_URI, contact).toPromise()
    } catch (error) {
      throw error;
    }
  }

  async sendEmploymentFormContact(contact: any) {
    try {
      return this.http.post<any>(this.EMPLOYMENT_URI, contact).toPromise()
    } catch (error) {
      throw error;
    }
  }

  createProspectQuotation(quotationInputs: QuotationInputs, quotationPaymentsInputs: QuotationPaymentsInputs, prospect: Prospect, kidData: KidPricingData): Observable<any> {
    try {
      return this.http.post<{ code: number, message: string, data: any }>(`${this.quoteRouter}/crate-website-quote`, { quotationInputs, quotationPaymentsInputs, prospect, kidData }, { headers: this.headers })
    } catch (error) {
      throw error
    }
  }

}
